import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { LazyMotion, domMax, MotionConfig } from 'framer-motion';
import { queryClient } from '@/api/queryClient';
import { featureRoutes } from '@/router/registry';
import { rootRoutes } from '@/router/rootRoutes';
import { NotFoundPage } from '@/features/errors/pages/NotFoundPage';
import { ToastViewport } from '@/components/ui/Toast';
import { usePwaUpdate } from '@/hooks/usePwaUpdate';
import { useLang } from '@/lib/i18n';
import { useTheme } from '@/lib/theme';

/**
 * CLAUDE.md §6 — App.tsx FAQAT provider'lar + RouterProvider.
 * Boshqa agentlar bu faylga TEGMAYDI — faqat features/<domain>/routes.tsx yaratadi.
 */
const router = createBrowserRouter([
  ...rootRoutes,
  ...featureRoutes,
  { path: '*', element: <NotFoundPage /> }, // har doim OXIRIDA
]);

export default function App() {
  usePwaUpdate();
  // Til o'zgarganda butun daraxt qayta mount bo'ladi — shu sabab `t()` oddiy
  // funksiya bo'la oladi va 200+ faylga `useT()` tarqatish shart emas.
  // Til almashtirish kamdan-kam bo'ladigan amal (faqat Profil sahifasida).
  const { lang } = useLang();
  // Tema ham kalitda: chart ranglari CSS o'zgaruvchilardan JS orqali o'qiladi,
  // shuning uchun tema almashganda daraxt qayta render bo'lishi shart.
  const { resolved: theme } = useTheme();
  return (
    <QueryClientProvider client={queryClient}>
      {/* domMax (~34KB) ishlatiladi, TZ-docs/08 §8.6 dagi domAnimation (12KB) EMAS —
          BottomSheet/SlideToConfirm "drag" va BottomNav/Tabs "layoutId" domMax talab qiladi.
          Tafsilot: QUESTIONS.md Q-004. */}
      {/* reducedMotion="user" — TZ-docs/08 §8.6, prefers-reduced-motion. index.css'dagi
          @media qoidasi faqat oddiy CSS transition/animation'larni o'chiradi; 15 ta fayldagi
          `m.*` (framer-motion) animatsiyalari buni hisobga olmaydi edi. MotionConfig markazda
          o'rnatilgani uchun har bir faylni alohida tuzatish shart emas — barcha `m.*`
          komponentlari OS darajasidagi sozlamani avtomatik hurmat qiladi. */}
      <MotionConfig reducedMotion="user">
        <LazyMotion features={domMax} strict>
          <ToastViewport />
          <RouterProvider key={`${lang}-${theme}`} router={router} />
        </LazyMotion>
      </MotionConfig>
    </QueryClientProvider>
  );
}
